import { Grid, Paper, Typography } from "@mui/material";
import { Suspense } from "react";

import CanceledVsCompleted from "../CanceledVsCompleted";
import DeliveryProgressChart from "../DeliveryProgress";
import DeliveryStatsByType from "../DeliveryStatsByType";

export function AdminDashboard() {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        p: 2,
      }}
    >
      <Grid size={{ xs: 12 }}>
        <Paper
          sx={{
            height: 500,
          }}
        >
          <Suspense fallback={<div>Loading...</div>}>
            <DeliveryStatsByType />
          </Suspense>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, md: 7 }}>
        <Paper
          sx={{
            height: 500,
            p: 2,
          }}
        >
          <DeliveryProgressChart />
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, md: 5 }}>
        <Paper
          sx={{
            height: 500,
            p: 2,
          }}
        >
          <Typography variant="h6">Livraisons annulées vs Livraisons complétées</Typography>
          <Suspense fallback={<div>Loading chart...</div>}>
            <CanceledVsCompleted />
          </Suspense>
        </Paper>
      </Grid>
      {/*       <Grid xs={12}>
        <Paper
          sx={{
            height: 500,
            p: 2,
          }}
        >
          <Typography variant='h6'>Marge de livraison</Typography>
          <DeliveryMarginStats />
        </Paper>
      </Grid> */}
    </Grid>
  );
}
